import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[inputfieldFloatLabel]',
    standalone: false,
})
export class InputFieldFloatLabelDirective {
    constructor(public el: ElementRef) { }
}